import { EventEmitter, Injectable, NgModule, Output } from "@angular/core";
import { ShoppingProduct, ShoppingService } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';

@NgModule()
@Injectable()
export class ShoppingCart
{
    @Output() totalUpdated = new EventEmitter<number>();
    @Output() navbarItemClicked = new EventEmitter<void>();
    @Output() serviceCountUpdated = new EventEmitter<any>();
    @Output() productCountUpdated = new EventEmitter<number>(); // index

    public caseId: number = null;
    public productList: ShoppingProduct[] = []; // array of products to be purchased
    public serviceList: ShoppingService[] = []; // array of services to be purchased

    // appends a new product to the list of products to be purchased
    // or updates an existing product
    public pushProduct(myproduct: ShoppingProduct)
    {
      const productName: string = myproduct.productName;
      const productIndex: number = this.getProductIndexByName(productName);
      if (productIndex !== -1)
      {
        // updates an existing product
        this.productList[productIndex].quantity += 1;
        this.productCountUpdated.emit(productIndex);
      }
      else
      {
        // appends a new product
        this.productList.push(myproduct);
      }
      this.totalUpdated.emit(this.getTotal());
    }

    public pushService(myservice: ShoppingService)
    {
      const serviceName: string = myservice.serviceName;
      const serviceIndex: number = this.getServiceIndexByName(serviceName);
      if (serviceIndex !== -1)
      {
        // updates an existing service
        this.serviceList[serviceIndex] = myservice;
      }
      else
      {
        this.serviceList.push(myservice);
      }
      this.totalUpdated.emit(this.getTotal());
    }

    // removes product at index position
    public removeAt(productIndex: number)
    {
      this.productList.splice(productIndex, 1);
      this.totalUpdated.emit(this.getTotal());
    }

    // removes service at index position
    public removeServiceAt(serviceIndex: number)
    {
      this.serviceList.splice(serviceIndex, 1);
      this.totalUpdated.emit(this.getTotal());
    }

    // gets the product index by name
    public getProductIndexByName(productName: string)
    {
      for (let i: number = 0; i < this.productList.length; i++)
      {
        if (this.productList[i].productName === productName)
        {
          return i; // index found
        }
      }
      return -1;
    }

    public getServiceIndexByName(serviceName: string)
    {
      return this.serviceList.findIndex(x => x.serviceName == serviceName);
    }

    // gets the total of the products in the shopping-cart
    public getTotal(): number
    {
      let total: number = 0.0;
      for (let i: number = 0; i < this.productList.length; i++)
      {
        total += this.productList[i].subtotal;
      }
      for (let i: number = 0; i < this.serviceList.length; i++)
      {
        total += this.serviceList[i].serviceTotal;
      }
      return total;
    }

    // gets the number of items
    public count(): number
    {
      let totalCount: number = 0;
      this.productList.map(x =>
      {
        totalCount += x.quantity;
      });
      return totalCount;
    }

    // gets the number of services
    public countServices(): number
    {
      let totalCount: number = 0;
      this.serviceList.map(x =>
      {
        totalCount += x.serviceCount;
      });
      return totalCount;
    }

    // clears all the lists
    public clearAll()
    {
      this.productList.clear();
      this.serviceList.clear();
    }

    public hideShoppingCartSidebar()
    {
      this.navbarItemClicked.emit();
    }
}
